import { useFirestore, useFirestoreDocData } from 'reactfire'
import { doc } from 'firebase/firestore'
import { Alert } from 'antd'
import DOMPurify from 'dompurify'

// Configure DOMPurify with strict allowlist to prevent XSS
const sanitizeConfig = {
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'br', 'p', 'ul', 'ol', 'li'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
}

export function AnnouncementAlert() {
  const firestore = useFirestore()

  const { data: announcement } = useFirestoreDocData(
    doc(firestore, 'configs', 'announcement')
  )

  return (
    announcement?.show &&
    announcement?.alwaysShow && (
      <Alert
        className="announcementBanner"
        type="warning"
        message={announcement.title}
        description={
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                announcement.message || '',
                sanitizeConfig
              ),
            }}
          />
        }
      />
    )
  )
}
